import { render } from "./Register.vue?vue&type=template&id=58bd92d8&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=58bd92d8&scoped=true&lang=scss"
import "./Register.vue?vue&type=style&index=1&id=58bd92d8&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bd92d8"]])

export default __exports__